
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Options({
  name: 'ErrorDialog',
  emits: ['update:modelValue'],
})
export default class ErrorDialog extends Vue {
  @Prop({ type: Boolean, default: false })
  modelValue!: boolean

  handleClose() {
    this.$emit('update:modelValue', false)
  }
}
